import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../../pagination.js';
import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

export const ApplicableCatalogQuerySchema = PaginationSchema.extend({
  vehicleModelId: z.uuid(),
  manufactureYear: z.coerce.number().int().min(1900).max(2100).optional(),
  vehicleEngineId: z.uuid().optional(),
  vehicleGenerationId: z.uuid().optional(),
  vehicleTrimId: z.uuid().optional(),
  placeId: z.uuid().optional(),
  status: CatalogItemStatusSchema.optional(),
});

export const ApplicableCatalogMatchSchema = z.object({
  applicationId: z.uuid(),
  matchType: z.enum(['MODEL', 'FREE_TEXT']),
  yearMatched: z.boolean(),
  engineMatched: z.boolean(),
  generationMatched: z.boolean().optional(),
  trimMatched: z.boolean().optional(),
});

export const ApplicableProductItemSchema = z.object({
  kind: z.literal('PRODUCT'),
  id: z.uuid(),
  name: z.string(),
  code: z.string().nullable(),
  sku: z.string().nullable(),
  status: CatalogItemStatusSchema,
  match: ApplicableCatalogMatchSchema,
});

export const ApplicableServiceItemSchema = z.object({
  kind: z.literal('SERVICE'),
  id: z.uuid(),
  name: z.string(),
  code: z.string().nullable(),
  status: CatalogItemStatusSchema,
  usefulLifeMonths: z.number().int().nullable(),
  usefulLifeMeters: z.number().int().nullable(),
  alertMonths: z.number().int().nullable(),
  alertMeters: z.number().int().nullable(),
  estimatedDurationMinutes: z.number().int().nullable(),
  match: ApplicableCatalogMatchSchema,
});

export const ListApplicableProductsResponseSchema = z.object({
  items: z.array(ApplicableProductItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export const ListApplicableServicesResponseSchema = z.object({
  items: z.array(ApplicableServiceItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ApplicableCatalogQuery = z.infer<typeof ApplicableCatalogQuerySchema>;
export type ApplicableCatalogMatch = z.infer<typeof ApplicableCatalogMatchSchema>;
export type ApplicableProductItem = z.infer<typeof ApplicableProductItemSchema>;
export type ApplicableServiceItem = z.infer<typeof ApplicableServiceItemSchema>;
export type ListApplicableProductsResponse = z.infer<typeof ListApplicableProductsResponseSchema>;
export type ListApplicableServicesResponse = z.infer<typeof ListApplicableServicesResponseSchema>;
